import { convertDate } from 'Frontend/scripts/convertDates'
import { IWorkroomPosts } from 'Frontend/scripts/models/workrooms.model'
import { FunctionComponent, useEffect, useRef, useState } from 'react'
import { getWorkroomPosts } from 'Frontend/scripts/services/workrooms.service'
import { Button } from 'react-bootstrap'
import Paging from 'Features/Paging/paging'
import { useTranslation } from 'react-i18next'

interface WorkroomPostsProps {
  id: number
  permissionToCreatePost: boolean | undefined
  callback: (_activeType: number, postId?: number) => void | null
}

const WorkroomPosts: FunctionComponent<WorkroomPostsProps> = ({ id, permissionToCreatePost, callback }) => {
  const url = new URL(window.location.href)
  const [posts, setPosts] = useState<IWorkroomPosts>()
  const [pageIndex, setPageIndex] = useState<number>(
    url.searchParams.get('page') !== null ? Number(url?.searchParams?.get('page')) : 1,
  )
  const postListRef = useRef<HTMLDivElement | null>(null)
  const { t } = useTranslation()

  useEffect(() => {
    getWorkroomPosts(id, pageIndex).then((postData) => {
      setPosts(postData)
    })
  }, [pageIndex])

  const changePage = (activePage: number) => {
    setPageIndex(activePage)
    postListRef?.current && postListRef.current.scrollIntoView()
  }

  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        <h2 className="mb-0">{t('posts')}</h2>
        {permissionToCreatePost && (
          <Button variant="secondary" className="text-white" onClick={() => callback(2)}>
            {t('new-post')}
          </Button>
        )}
      </div>
      <div className="d-flex flex-column gap-2" ref={postListRef}>
        {posts?.items.map((item) => (
          <div className="livstecknet__listing-content-row" key={`result-${item.id}`}>
            <div>
              <h3 className="livstecknet__listing-content-row-link">
                <button onClick={() => callback(1, item.id)} className="workrooms__listing-item-button stretched-link">
                  {item?.title}
                </button>
              </h3>
              <p className="livstecknet__listing-content-row-text">{convertDate(item?.created)}</p>
              <div className="d-flex gap-3">
                <div>
                  <span className="fw-bold">{t('number-of-answers')}:</span>{' '}
                  <span className="fa fa-comment-o me-1"></span>
                  {item?.totalComments}
                </div>
              </div>
            </div>
          </div>
        ))}
        {(posts?.totalPages as number) > 1 && (
          <Paging
            noOfPages={posts?.totalPages as number}
            activePage={posts?.pageIndex as number}
            callback={(activePage) => {
              changePage(activePage)
            }}
          />
        )}
      </div>
    </>
  )
}
export default WorkroomPosts
